interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ className = "", style }: SkeletonProps) {
  return (
    <div
      className={`relative overflow-hidden rounded-xl bg-slate-200/70 ${className}`}
      style={style}
    >
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent skeleton-shimmer" />
      <style>{`
        @keyframes skeleton-shimmer { 100% { transform: translateX(100%); } }
        .skeleton-shimmer { animation: skeleton-shimmer 1.4s ease-in-out infinite; }
      `}</style>
    </div>
  );
}

/** 홈페이지 배너 로딩 시 스켈레톤 — 실제 레이아웃과 동일한 구조 */
export function HomeBannersSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-[var(--content-width)] flex-col" style={{ gap: "15px", padding: "15px 0 0" }}>
      {/* VIP 큰 배너 */}
      <div style={{ padding: "0 7.5px" }}>
        <Skeleton className="w-full " style={{ aspectRatio: "16/9" }} />
      </div>
      {/* Platinum 2열 */}
      <div className="grid grid-cols-2" style={{ gap: "15px", padding: "0 7.5px" }}>
        {Array.from({ length: 2 }).map((_, i) => (
          <Skeleton key={i} className="" style={{ aspectRatio: "16/9" }} />
        ))}
      </div>
      {/* Gold 3열 */}
      <div className="grid grid-cols-3" style={{ gap: "15px", padding: "0 7.5px" }}>
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="" style={{ aspectRatio: "16/9" }} />
        ))}
      </div>
      {/* Standard 5열 × 2행 */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5" style={{ gap: "15px", padding: "0 7.5px" }}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton key={i} className="" style={{ aspectRatio: "16/9" }} />
        ))}
      </div>
    </div>
  );
}
